import React from 'react'
import { Layout } from './Layout'
import type { ChannelProviderProps } from './Context'
import { ChannelProvider } from './Context'

export * from './Context'

/**
 * The default Channel layout implementation
 */
export const Channel = (props: Omit<ChannelProviderProps, 'children'>) => {
  return (
    <ChannelProvider {...props}>
      <Layout />
    </ChannelProvider>
  )
}
